import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../../../contexts/UserContext';
import Feeds from '../../components/Feeds';

const ArchivedActivities = ({ history }) => {
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);

    const canSeeFeedsOfResidents =
        activeRegistrantsIndexes[0] === 'all-users'
            ? listOfResidents
                  .filter((resident) => resident.manager || resident.canSeeFeed)
                  .map((resident) => resident._id)
            : activeRegistrantsIndexes
                  .filter(
                      (residentIndex) =>
                          listOfResidents[residentIndex].manager || listOfResidents[residentIndex].canSeeFeed,
                  )
                  .map((residentIndex) => listOfResidents[residentIndex]._id);

    return (
        <div className="relative-list">
            {listOfResidents.length ? (
                !canSeeFeedsOfResidents.length ? (
                    <div className="no-invites">
                        You don't have access to the archive of the resident. Please request the manager of the resident
                        to provide you access.
                    </div>
                ) : (
                    <>
                        <Feeds history={history} lastUpdated={Date.now()} isArchived={true} />
                    </>
                )
            ) : (
                <div>
                    <Redirect to={'/message-recipients'} />
                </div>
            )}
        </div>
    );
};

export default ArchivedActivities;
